var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1224,
    height: 269,
    viewBox: "0 0 1224 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-107 275.296C-38.2275 275.296 30.565 275.587 99.3275 275.444C160.78 275.318 222.093 272.581 283.526 272.109C397.964 271.231 512.382 272.251 626.81 271.215C728.376 270.293 830.99 267.852 932.486 271.577C991.643 273.771 1050.19 274.769 1109.4 275.674C1183.29 276.804 1257.1 273.738 1330.96 275.296",
    stroke: "url(#paint0_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-107 267.364C-39.2161 267.364 28.7476 267.989 96.5115 267.314C160.191 266.678 223.501 262.219 287.131 261.072C401.789 259.004 515.547 264.912 630.085 263.859C730.872 262.948 830.231 255.554 931.128 262.169C990.105 266.036 1047.25 269.064 1106.66 269.947C1181.55 271.045 1256.08 265.707 1330.96 267.364",
    stroke: "url(#paint1_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-107 259.586C-40.4443 259.586 26.6006 260.584 93.1063 259.207C159.612 257.83 225.169 251.495 291.475 249.449C351.75 247.589 411.175 248.088 471.13 252.136C524.864 255.768 577.06 258.39 631.233 257.995C678.716 257.644 723.203 253.683 770.097 249.992C823.761 245.762 879.012 247.737 932.177 253.124C990.694 259.059 1045.89 264.736 1105.64 265.384C1181.01 266.206 1255.54 258.165 1330.96 259.586",
    stroke: "url(#paint2_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-107 251.917C-41.8823 251.917 24.224 253.261 89.2318 251.111C158.693 248.818 226.977 240.513 296.288 237.397C355.799 234.687 415.708 236.545 474.286 242.915C526.582 248.522 577.14 253.53 630.594 253.299C680.094 253.085 724.881 246.201 772.933 240.634C827.475 234.314 881.449 236.711 935.163 244.375C992.731 252.603 1045.88 261.467 1106.04 261.703C1181.54 262.005 1255.33 250.995 1330.96 251.922",
    stroke: "url(#paint3_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-107 244.369C-43.4201 244.336 21.7175 246.015 85.0777 243.08C157.815 239.739 228.874 229.432 301.341 225.126C362.155 221.517 418.355 224.874 477.012 233.941C527.231 241.709 575.872 249.487 628.547 249.503C680.633 249.503 726.968 239.163 776.398 231.616C832.708 223.02 884.634 225.521 939.656 235.905C995.657 246.47 1047.07 258.944 1107.57 258.67C1182.96 258.297 1255.36 244.117 1330.96 244.369",
    stroke: "url(#paint4_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-107 236.942C-45.0279 236.892 19.1312 238.757 80.7339 235.148C156.806 230.694 230.522 218.395 306.324 212.844C367.987 208.33 421.511 213.157 479.219 225.236C526.831 235.203 573.595 246.003 625.412 246.344C680.174 246.706 729.544 232.504 780.192 222.943C838.679 211.901 888.619 214.249 945.138 227.704C998.962 240.518 1049.15 256.969 1109.9 256.047C1185.03 254.906 1255.52 237.468 1330.94 236.942",
    stroke: "url(#paint5_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-107 229.635C-46.6156 229.57 16.5449 231.555 76.4799 227.348C155.807 221.78 232.189 207.551 311.147 200.76C374.058 195.346 424.546 201.545 481.036 216.805C525.713 228.873 570.589 242.811 621.687 243.546C679.126 244.364 732.46 225.916 784.276 214.578C811.418 208.67 840.027 203.135 869.616 204.408C898.574 205.659 925.996 212.356 951.32 219.767C1002.37 234.671 1052.1 255.186 1112.84 253.617C1187.63 251.681 1255.77 230.996 1330.97 229.652",
    stroke: "url(#paint6_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.951 222.455C-48.0347 222.372 14.0972 224.408 72.3946 219.712C154.748 213.097 233.516 197.03 315.4 189.065C379.749 182.801 427.321 190.256 482.284 208.659C523.954 222.614 566.953 239.668 617.592 240.825C677.507 242.191 735.425 219.405 788.23 206.509C815.891 199.751 846.397 192.625 877.294 194.194C906.253 195.664 933.384 203.695 957.6 212.022C1005.88 228.631 1055.1 253.288 1116 251.089C1190.47 248.39 1255.98 224.561 1330.98 222.455",
    stroke: "url(#paint7_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.94 215.4C-49.432 215.302 11.7813 217.337 68.5907 212.296C153.63 204.742 234.516 186.981 318.936 177.952C351.08 174.518 381.547 172.532 413.032 178.555C438.686 183.465 461.254 192.082 483.023 200.793C521.968 216.366 563.08 236.338 613.598 237.902C675.71 239.827 738.281 212.91 791.945 198.697C820.085 191.243 852.47 182.609 884.544 184.435C913.633 186.081 940.405 195.335 963.582 204.474C1009.3 222.488 1057.93 251.001 1119.15 248.242C1193.36 244.89 1256.15 218.11 1331.02 215.373",
    stroke: "url(#paint8_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.93 208.462C-50.6295 208.358 9.75489 210.382 65.2562 205.11C152.453 196.827 234.876 177.541 321.423 167.661C353.677 163.981 384.054 161.699 415.38 168.534C440.794 174.112 462.453 183.684 483.164 193.251C519.822 210.162 559.216 232.641 609.984 234.534C642.428 235.746 675.052 226.448 703.072 218.577C734.158 209.844 764.046 199.894 795.122 191.15C823.681 183.119 857.633 173.267 890.786 175.324C920.084 177.14 946.437 187.337 968.785 197.156C1012.4 216.355 1060.12 248.094 1121.93 244.879C1196 241.039 1256.17 211.594 1331.03 208.44",
    stroke: "url(#paint9_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.92 201.649C-51.6283 201.544 8.11699 203.574 62.5498 198.204C151.284 189.455 234.666 168.852 322.661 158.358C354.766 154.518 385.372 152.066 416.378 159.389C441.762 165.385 462.772 175.78 482.734 186.004C517.864 203.991 555.771 228.335 607.158 230.436C640.491 231.785 674.063 221.714 702.523 213.387C734.647 203.98 765.433 193.273 797.558 183.854C826.517 175.357 861.467 164.732 895.509 166.899C925.117 168.786 951.02 179.619 972.76 190.003C1015.03 210.184 1061.28 244.199 1124.08 240.771C1198.16 236.728 1256.03 204.918 1331.04 201.671",
    stroke: "url(#paint10_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.9 194.957C-52.3877 194.869 6.98814 196.937 60.6221 191.611C150.105 182.724 233.717 161.041 322.391 150.262C354.056 146.422 385.232 143.921 415.799 151.293C441.392 157.464 462.113 168.419 481.705 179.077C516.276 197.913 553.064 223.234 605.53 225.275C639.601 226.602 673.264 216.427 702.123 207.721C734.926 197.848 766.282 186.592 799.075 176.707C828.404 167.865 863.504 157.069 898.245 159.22C928.202 161.074 953.666 172.105 975.136 182.933C1017.08 204.079 1061.12 238.955 1125.39 235.56C1199.66 231.638 1255.78 197.87 1331.1 194.968",
    stroke: "url(#paint11_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.891 188.374C-52.5776 188.188 6.60848 190.513 60.0128 185.083C148.887 176.026 231.43 153.695 319.405 142.664C350.98 138.709 382.136 136.34 412.683 143.624C438.646 149.828 459.776 160.914 479.658 171.704C514.868 190.815 552.045 216.459 605.2 218.851C639.511 220.392 672.974 210.343 701.963 201.501C734.816 191.473 766.112 179.998 798.955 169.965C828.423 160.958 863.344 150.311 898.344 152.615C928.502 154.6 953.816 165.654 975.325 176.602C1017.44 198.045 1060.64 232.46 1125.42 229.262C1199.9 225.598 1255.44 190.908 1331.07 188.374",
    stroke: "url(#paint12_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.88 181.94C-52.3372 181.599 6.66915 184.534 60.2632 178.725C147.559 169.263 228.245 146.564 314.613 135.144C346.567 130.914 376.904 128.715 407.89 136.049C434.323 142.297 456.202 153.267 476.813 163.964C513.191 182.867 551.936 208.769 605.091 212.032C639.192 214.128 672.775 204.051 701.514 195.214C733.968 185.236 764.794 173.75 797.238 163.761C826.647 154.705 861.567 144.14 896.518 146.877C926.585 149.23 952.269 160.442 974.078 171.27C1016.41 192.28 1060.86 226.048 1124.86 222.943C1199.52 219.317 1255.24 184.43 1331.05 181.94",
    stroke: "url(#paint13_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.86 175.615C-52.0081 175.209 6.83847 178.961 60.762 172.812C146.281 163.059 224.859 140.064 309.41 128.381C341.634 123.916 371.262 121.924 402.597 129.165C429.439 135.369 452.197 146.055 473.577 156.669C511.174 175.319 551.706 201.128 604.811 205.182C638.603 207.765 671.926 197.897 700.405 189.098C732.31 179.225 762.487 167.81 794.372 157.941C823.69 148.869 858.281 138.605 893.072 141.732C923.169 144.442 949.312 155.703 971.611 166.416C1014.5 186.987 1060.41 219.91 1123.92 216.849C1198.91 213.24 1254.94 178.128 1331.08 175.648",
    stroke: "url(#paint14_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.84 169.411C-51.6081 169.022 7.20848 173.767 61.5115 167.305C145.073 157.371 221.365 134.14 303.928 122.253C336.282 117.596 365.351 115.846 396.946 122.879C424.267 128.956 447.874 139.335 470.082 149.757C509.247 168.073 551.197 193.508 604.452 198.308C637.845 201.314 670.578 191.874 698.778 183.136C729.984 173.459 759.392 162.143 790.578 152.456C819.787 143.378 853.709 133.624 888.29 137.097C918.527 140.141 945.209 151.359 968.176 161.924C1011.92 182.039 1059.48 213.953 1122.65 210.908C1198.09 207.271 1254.55 171.923 1331.15 169.428",
    stroke: "url(#paint15_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.83 163.328C-51.149 163.021 7.64763 168.907 62.44 162.165C143.904 152.143 217.77 128.704 298.206 116.751C330.54 111.935 359.209 110.438 390.964 117.163C418.775 123.054 443.21 133.07 466.327 143.175C507.269 161.073 550.498 185.9 603.952 191.391C668.461 198.023 733.648 163.509 785.924 147.239C815.023 138.177 848.026 129.099 882.308 132.9C912.785 136.285 940.026 147.393 963.782 157.799C1008.64 177.442 1057.97 208.215 1120.98 205.154C1196.98 201.468 1253.98 165.862 1331.13 163.328",
    stroke: "url(#paint16_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.811 157.371C-50.6402 157.201 8.16646 164.348 63.528 157.371C142.806 147.344 214.125 123.795 292.324 111.804C324.548 106.867 352.938 105.638 384.783 111.974C413.102 117.618 438.387 127.19 462.412 136.976C505.132 154.365 549.649 178.364 603.373 184.535C666.903 191.819 729.284 158.303 780.591 142.297C808.961 133.46 842.034 124.552 875.377 129.105C906.333 133.328 933.605 143.57 958.709 153.992C1004.85 173.136 1056.08 202.664 1119.09 199.57C1195.74 195.813 1253.35 159.938 1331.15 157.333",
    stroke: "url(#paint17_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.79 151.529C-50.0904 151.529 8.77612 160.048 64.7568 152.812C141.778 142.856 210.48 119.209 286.373 107.284C418.186 86.5543 486.948 163.081 602.734 177.727C665.146 185.631 724.372 153.323 774.75 137.64C802.99 128.863 834.785 120.871 867.709 125.682C899.054 130.262 926.964 140.278 953.077 150.503C1000.66 169.153 1053.87 197.337 1117.02 194.194C1194.38 190.354 1252.66 154.2 1331.18 151.529",
    stroke: "url(#paint18_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.771 145.813C-49.5217 146.043 9.44474 155.961 66.0944 148.512C140.818 138.687 206.895 114.985 280.421 103.164C409.508 82.4182 488.126 155.275 602.045 170.969C663.378 179.427 719.049 148.55 768.509 133.169C796.629 124.425 827.036 117.486 859.49 122.516C891.255 127.453 919.874 137.217 947.036 147.228C996.146 165.33 1051.39 192.159 1114.8 188.944C1192.92 184.99 1251.93 148.572 1331.21 145.813",
    stroke: "url(#paint19_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.75 140.218C-48.932 140.684 10.1543 152.05 67.513 144.414C139.95 134.771 203.32 111.041 274.569 99.3794C400.92 78.694 489.265 147.569 601.336 164.31C661.571 173.306 713.457 143.948 762.048 128.869C790.069 120.175 818.968 114.349 850.922 119.544C883.127 124.804 912.485 134.354 940.725 144.118C991.413 161.671 1048.69 187.102 1112.42 183.816C1191.31 179.74 1251.11 143.049 1331.17 140.196",
    stroke: "url(#paint20_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.73 134.744C-48.3532 135.451 10.9028 148.271 69.0204 140.476C139.221 131.052 199.975 107.311 268.927 95.8467C392.592 75.282 490.383 140.021 600.617 157.766C659.763 167.288 707.755 139.494 755.517 124.705C783.418 116.066 810.909 111.387 842.334 116.768C874.988 122.363 905.115 131.672 934.414 141.194C986.689 158.199 1045.99 182.225 1110.11 178.857C1189.83 174.666 1250.37 137.717 1331.23 134.744",
    stroke: "url(#paint21_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.711 129.395C-47.7945 130.339 11.6613 144.579 70.4479 136.653C138.491 127.476 196.679 103.74 263.434 92.5007C384.652 72.095 491.511 132.621 599.957 151.359C658.025 161.397 702.112 135.166 749.096 120.641C776.876 112.056 803.019 108.523 833.846 114.058C866.949 119.993 897.835 129.088 928.182 138.348C981.996 154.771 1043.27 177.442 1107.84 174.003C1188.35 169.697 1249.64 132.445 1331.29 129.406",
    stroke: "url(#paint22_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.69 124.162C-47.1848 125.33 12.4107 140.936 71.9164 132.9C137.913 123.986 193.644 100.268 258.322 89.2694C377.214 69.0502 492.62 125.374 599.249 145.105C656.348 155.67 696.491 130.893 742.825 116.658C770.516 108.156 795.291 105.687 825.598 111.381C859.13 117.656 890.766 126.57 922.101 135.561C977.393 151.419 1040.55 172.757 1105.57 169.23C1186.85 164.814 1248.85 127.294 1331.25 124.162",
    stroke: "url(#paint23_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.67 119.055C-46.6051 120.416 13.1602 137.305 73.3349 129.187C137.444 120.542 190.868 96.8229 253.609 86.0825C314.473 75.6603 379.221 87.4265 436.071 99.999C490.893 112.127 543.009 128.035 598.65 139.033C655.03 150.179 690.989 126.57 736.974 112.703C798.038 94.2997 860.579 117.64 916.47 132.774C973.099 148.089 1038.04 168.155 1103.48 164.551C1185.48 160.042 1248.16 122.259 1331.29 119.05",
    stroke: "url(#paint24_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.65 114.063C-46.0263 115.583 13.7489 133.641 74.6925 125.462C137.094 117.08 188.391 93.378 249.445 82.8735C309.749 72.4841 376.205 83.7676 433.324 95.2814C489.255 106.559 542.489 121.452 598.12 133.169C653.752 144.886 686.246 122.434 731.641 108.765C791.317 90.7999 856.464 115.896 911.386 129.966C969.204 144.776 1035.79 163.624 1101.6 159.971C1184.23 155.379 1247.53 117.344 1331.27 114.063",
    stroke: "url(#paint25_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.631 109.198C-45.4376 110.844 14.2877 129.911 75.9403 121.683C136.854 113.559 186.264 89.8677 245.7 79.5661C305.545 69.2261 373.518 80.0488 430.897 90.6082C487.816 101.091 542.119 115.089 597.661 127.525C623.864 133.389 643.066 133.63 668.4 126.066C688.991 119.917 706.407 110.986 726.967 104.793C754.399 96.5214 776.248 96.7518 804.977 102.901C839.498 110.301 873.13 118.809 907.002 127.075C965.789 141.381 1033.82 159.132 1099.93 155.446C1183.13 150.805 1246.96 112.517 1331.3 109.198",
    stroke: "url(#paint26_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.61 104.447C-44.8479 106.093 14.6977 126.071 77.0693 117.815C136.775 109.911 184.497 86.1318 242.734 76.0935C302.27 65.8303 371.492 76.2032 429.1 85.9672C486.709 95.7312 542.02 109.006 597.382 122.171C622.965 128.254 641.669 129.115 666.783 121.589C686.695 115.621 703.311 106.812 723.173 100.8C750.455 92.5387 771.964 93.4164 800.194 99.7685C834.885 107.574 869.037 116.066 903.548 124.102C963.073 137.958 1032.43 154.721 1098.64 151.024C1182.3 146.356 1246.56 107.837 1331.31 104.497",
    stroke: "url(#paint27_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.591 99.8289C-44.2492 101.431 14.9569 122.1 78.0275 113.822C136.844 106.093 183.079 82.1331 240.507 72.391C299.963 62.2924 369.934 72.1935 427.901 81.2609C486.339 90.3941 542.13 103.115 597.261 117.004C622.326 123.312 640.82 124.639 665.744 117.113C685.117 111.271 701.064 102.517 720.377 96.62C747.528 88.3316 769.018 89.6755 796.818 96.2689C831.559 104.497 866.11 113.01 901.151 120.876C961.066 134.332 1031.59 150.229 1097.74 146.559C1181.73 141.896 1246.3 103.159 1331.41 99.8289",
    stroke: "url(#paint28_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.57 95.3256C-43.6595 96.7793 15.0373 117.947 78.8069 109.648C137.014 102.073 182.25 78.0083 238.99 68.3814C298.256 58.3322 369.145 68.0194 427.263 76.5217C486.299 85.1612 542.34 97.5362 597.212 112.177C621.867 118.759 640.461 120.35 665.256 112.775C684.229 106.977 699.677 98.2164 718.62 92.3635C745.672 84.0038 767.461 85.5836 794.932 92.4787C829.603 101.179 864.413 109.752 899.843 117.487C959.938 130.602 1031.28 145.786 1097.16 142.171C1181.35 137.558 1246.08 98.6114 1331.39 95.3256",
    stroke: "url(#paint29_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.541 90.9373C-43.3107 92.2428 14.9767 113.641 79.1358 105.265C137.144 97.6953 182.11 73.6528 238.67 64.0808C297.876 54.0645 369.085 63.9492 427.222 72.2705C486.468 80.7509 542.329 93.0327 597.271 107.739C621.836 114.322 640.69 115.693 665.315 108.167C684.158 102.407 699.506 93.7239 718.35 87.9478C745.311 79.6868 767.5 81.2227 794.711 88.3153C829.232 97.3113 864.083 105.951 899.663 113.608C959.468 126.483 1031.74 141.496 1097.11 137.744C1181.18 132.928 1246.33 94.6399 1331.42 90.9538",
    stroke: "url(#paint30_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.521 86.62C-43.1503 87.8597 14.9673 109.401 79.2761 100.926C137.194 93.2903 182.39 69.4508 238.99 59.9391C298.196 49.9886 369.245 60.3066 427.293 68.6828C486.349 77.2071 541.97 89.4669 597.292 103.477C649.658 116.735 675.611 96.3456 718.74 83.6305C745.701 75.6822 768.03 77.1303 794.992 84.2503C829.363 93.3287 864.154 101.946 899.723 109.516C959.179 122.165 1032.39 137.25 1097.29 133.18C1181 127.925 1246.95 91.1948 1331.47 86.7023",
    stroke: "url(#paint31_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.501 82.3692C-42.9411 83.565 15.0367 105.265 79.5453 96.719C137.463 89.0394 182.839 65.4522 239.469 56.0283C298.675 46.1546 369.514 56.8676 427.472 65.2712C486.299 73.801 541.71 86.006 597.351 99.3081C649.278 111.727 676.159 91.6998 719.318 79.5607C746.28 71.9579 768.808 73.3622 795.53 80.4932C829.742 89.6209 864.433 98.1726 899.992 105.611C959.208 118.002 1033.14 132.928 1097.51 128.584C1180.8 122.967 1247.56 87.8326 1331.46 82.627",
    stroke: "url(#paint32_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.48 78.1948C-42.7009 79.3577 15.1871 101.233 79.9353 92.6488C137.783 84.9802 183.429 61.6618 240.098 52.3366C299.304 42.6275 369.914 53.6092 427.762 62.0184C486.309 70.5207 541.601 82.6325 597.442 95.1995C648.999 106.79 676.799 87.2073 720.068 75.6331C747.1 68.4088 769.797 69.8131 796.32 76.9386C830.341 86.0828 864.962 94.5357 900.462 101.798C959.528 113.894 1033.91 128.452 1097.84 123.883C1180.72 117.964 1248.25 84.481 1331.51 78.6336",
    stroke: "url(#paint33_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.461 74.0915C-42.4117 75.2434 15.3664 97.2892 80.4441 88.6991C138.242 81.0744 184.167 58.0193 240.887 48.8806C300.073 39.3416 370.323 50.5701 428.151 58.9518C486.379 67.3993 541.501 79.3849 597.571 91.195C648.739 101.974 677.518 82.9065 720.986 71.9577C748.108 65.1229 770.985 66.5765 797.338 73.6801C831.094 82.8707 865.732 91.0486 901.101 98.1779C960.117 109.939 1034.71 123.959 1098.27 119.181C1180.61 113.021 1248.97 81.228 1331.5 74.8265",
    stroke: "url(#paint34_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.431 70.065C-42.0919 71.217 15.6663 93.4548 81.0635 84.8756C138.812 77.3112 185.046 54.5633 241.836 45.6112C301.002 36.286 370.953 47.6901 428.671 56.0334C486.589 64.3931 541.561 76.2142 597.761 87.2563C648.549 97.2397 678.367 78.7374 722.095 68.4523C749.346 62.0399 772.394 63.5758 798.596 70.6465C832.149 79.7762 866.661 87.8009 901.95 94.678C960.996 106.071 1035.58 119.329 1098.8 114.425C1180.61 108.079 1249.75 78.0243 1331.56 71.1237",
    stroke: "url(#paint35_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.411 66.1266C-41.7428 67.284 16.0053 89.7137 81.7721 81.2004C139.48 73.7293 186.044 51.3105 242.854 42.5723C301.99 33.4775 371.571 45.0188 429.239 53.2907C486.728 61.5188 541.68 73.1533 597.94 83.411C648.369 92.61 679.285 74.7386 723.313 65.1502C750.714 59.1821 773.941 60.8332 800.034 67.8929C833.357 76.9353 867.714 84.7794 902.888 91.3758C962.034 102.347 1036.39 114.722 1099.34 109.703C1180.58 103.23 1250.47 74.9471 1331.54 67.6241",
    stroke: "url(#paint36_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.391 62.2648C-41.3628 63.4496 16.4353 86.0933 82.5815 77.6239C140.25 70.2844 187.153 48.2222 244.023 39.7198C303.119 30.8884 372.321 42.5119 429.859 50.6906C486.948 58.809 541.84 70.1802 598.121 79.648C648.2 88.0681 680.274 70.8714 724.631 62.018C752.202 56.5326 775.609 58.3098 801.622 65.3092C834.725 74.2444 868.939 81.8791 904.007 88.1559C963.343 98.7043 1037.28 110.032 1100 104.925C1180.65 98.3422 1251.25 71.8971 1331.57 64.1957",
    stroke: "url(#paint37_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.371 58.4913C-40.9538 59.7091 16.8342 82.5722 83.4698 74.2179C141.098 66.9882 188.371 45.2989 245.3 37.0599C304.347 28.5191 373.119 40.1811 430.578 48.2556C487.267 56.2258 542.11 67.3118 598.34 75.9787C648.079 83.6583 681.382 67.1637 726.089 59.0728C753.849 54.0536 777.436 56.0229 803.389 62.9125C836.26 71.7123 870.312 79.1137 905.245 85.0516C964.81 95.1173 1038.15 105.276 1100.69 100.109C1180.74 93.5265 1252.01 68.8971 1331.57 60.8774",
    stroke: "url(#paint38_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.351 54.8105C-40.5239 56.0721 17.3241 79.1546 84.379 70.9156C142.037 63.8559 189.68 42.5396 246.679 34.5858C305.665 26.3577 373.958 38.0142 431.417 45.968C487.687 53.7682 542.49 64.5361 598.66 72.3966C648.06 79.3137 682.661 63.5871 727.737 56.297C755.697 51.777 779.454 53.9383 805.387 60.795C838.019 69.4403 871.901 76.583 906.683 82.1496C966.479 91.6997 1039.08 100.608 1101.48 95.3804C1180.9 88.7595 1252.81 66.05 1331.61 57.7561",
    stroke: "url(#paint39_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.331 51.2392C-40.095 52.5392 17.823 75.8412 85.4671 67.7393C143.035 60.8386 191.077 39.9393 248.136 32.2872C307.053 24.3827 374.877 36.0117 432.205 43.8065C488.066 51.4202 542.829 61.8315 598.879 68.8912C647.97 75.0787 683.939 60.1146 729.364 53.6637C757.524 49.6539 781.47 52.0181 807.414 58.8255C839.799 67.2978 873.499 74.1618 908.111 79.3354C968.296 88.3314 1039.99 95.8464 1102.3 90.6298C1181.1 84.0473 1253.58 63.2467 1331.63 54.7169",
    stroke: "url(#paint40_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.311 47.7285C-39.5951 49.1053 18.4326 72.6322 86.556 64.6838C144.114 57.9752 192.576 37.4928 249.675 30.1588C308.541 22.6054 375.856 34.1686 433.105 41.8317C488.546 49.2534 543.269 59.2698 599.169 65.5286C647.97 71.014 685.357 56.8562 731.122 51.2666C759.492 47.7834 783.618 50.3999 809.601 57.114C841.74 65.3964 875.253 71.9633 909.679 76.7243C970.233 85.1279 1040.93 91.2002 1103.15 85.9781C1181.34 79.4231 1254.34 60.6082 1331.65 51.8809",
    stroke: "url(#paint41_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.291 44.3335C-39.0963 45.7816 19.0313 69.5334 87.7239 61.7606C145.232 55.2494 194.083 35.2003 251.282 28.2009C310.069 21.0041 376.864 32.485 434.023 39.9781C489.065 47.1914 543.718 56.7853 599.439 62.2433C647.99 66.9991 686.825 53.697 732.939 48.9412C761.509 45.9955 785.804 48.8699 811.877 55.5237C843.766 63.6001 877.085 69.8499 911.306 74.174C972.22 81.9413 1041.84 86.5052 1104.03 81.305C1181.61 74.8268 1255.07 57.9976 1331.67 49.0948",
    stroke: "url(#paint42_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.271 41.042C-38.6074 42.5669 19.67 66.5436 88.8919 58.9573C146.41 52.6545 195.67 33.0498 252.939 26.396C311.646 19.5776 377.912 30.9434 435.031 38.2609C489.684 45.2657 544.256 54.3989 599.798 59.0615C648.139 63.1152 688.452 50.6798 734.896 46.8016C763.675 44.3935 788.141 47.5422 814.313 54.0972C845.954 61.9647 879.078 67.8918 913.084 71.7711C974.407 78.8637 1042.84 81.8697 1105.01 76.708C1181.9 70.312 1255.8 55.5124 1331.69 46.4615",
    stroke: "url(#paint43_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.251 37.8553C-38.0976 39.4625 20.3296 63.6366 90.1206 56.2807C147.639 50.1974 197.309 31.0369 254.647 24.7452C313.274 18.3273 379.001 29.5504 436.05 36.6814C490.333 43.4668 544.806 52.1118 600.108 55.9845C648.279 59.358 690.06 47.8058 736.804 44.8053C765.763 42.9457 790.418 46.3796 816.691 52.8523C848.086 60.496 881.009 66.0838 914.782 69.5005C976.494 75.88 1043.72 77.3007 1105.89 72.1774C1182.22 65.8911 1256.41 53.1376 1331.64 43.955",
    stroke: "url(#paint44_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.231 34.7832C-37.5788 36.4727 21.0182 60.8937 91.3684 53.7297C148.877 47.8659 198.986 29.1662 256.395 23.2639C314.922 17.23 380.099 28.3269 437.138 35.2604C491.062 41.8429 545.415 49.9558 600.487 53.0441C648.569 55.7429 691.777 45.0903 738.881 42.9729C768.049 41.6619 792.804 45.3974 819.326 51.7824C850.479 59.1984 883.202 64.4395 916.728 67.3829C1057.53 80.1584 1195.5 58.6063 1331.78 41.6015",
    stroke: "url(#paint45_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.211 31.8103C-37.049 33.593 21.7177 58.2279 92.6472 51.2889C150.156 45.6609 200.694 27.4274 258.173 21.8707C316.6 16.2208 381.228 27.1806 438.147 33.9112C491.761 40.2687 545.955 47.855 600.777 50.1424C648.849 52.1665 693.416 42.4629 740.868 41.2012C770.207 40.4333 795.171 44.4925 821.843 50.7842C852.64 58.0962 885.343 62.7588 918.546 65.337C1055.76 75.9951 1198.88 56.2093 1331.75 39.3197",
    stroke: "url(#paint46_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.191 28.9575C-36.5202 30.8335 22.4263 55.6823 93.9349 48.9737C151.453 43.5596 202.411 25.8144 259.96 20.6307C318.287 15.3811 382.356 26.1928 439.215 32.6985C492.54 38.8147 546.543 45.8635 601.116 47.4049C649.278 48.7652 695.103 39.9776 742.915 39.6101C772.423 39.3852 797.547 43.7626 824.429 49.9775C855.026 57.0482 887.51 61.3103 920.433 63.4277C983.154 67.4594 1046.75 64.0256 1108.96 59.0942C1183.59 53.1755 1258.33 46.6808 1331.77 37.1527",
    stroke: "url(#paint47_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.171 26.2203C-36.5895 28.1566 22.277 53.0493 93.7157 46.9167C151.005 41.9798 202.062 24.9257 259.161 19.753C316.879 14.5254 379.66 24.8983 436.02 31.1626C490.503 37.1966 545.695 43.9381 601.466 44.7829C650.976 45.5344 699.217 37.2295 748.617 38.2004C778.435 38.7873 803.29 44.1411 830.621 50.0872C859.011 56.2638 888.988 59.8019 919.305 61.4749C983.834 65.0349 1047.83 59.7854 1111.59 54.8321C1185.19 49.1163 1259.44 44.717 1331.82 35.1615",
    stroke: "url(#paint48_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.161 23.604C-36.1004 25.6335 23.0058 50.7347 94.9737 44.8379C152.273 40.1424 203.74 23.5381 260.928 18.7439C318.527 13.9387 380.808 24.1635 437.089 30.2248C491.312 36.0722 546.294 42.2927 601.775 42.2927C651.575 42.2927 700.885 35.0904 750.694 36.928C780.552 38.025 805.616 43.686 833.157 49.506C861.357 55.4631 891.135 58.6282 921.193 59.8788C985.931 62.5722 1048.82 55.6441 1112.57 50.8279C1185.69 45.3042 1259.93 42.9509 1331.8 33.2747",
    stroke: "url(#paint49_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.142 21.1136C-35.5517 23.2365 23.6744 48.5406 96.2515 42.8742C153.57 38.3981 205.437 22.2601 262.706 17.8388C320.184 13.3902 381.976 23.5437 438.227 29.4075C492.15 35.041 546.923 40.702 602.114 39.9011C652.273 39.1715 702.552 33.0498 752.781 35.7432C782.678 37.3504 807.943 43.313 835.663 49.0068C863.624 54.75 893.262 57.5421 923.039 58.3704C987.947 60.1861 1049.8 51.6124 1113.53 46.9279C1186.19 41.5851 1260.32 41.2889 1331.77 31.492",
    stroke: "url(#paint50_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.121 18.7492C-35.0419 20.9434 24.4338 46.4614 97.5202 41.0309C154.849 36.7687 207.115 21.0695 264.474 17.0433C321.832 13.017 383.125 23.0333 439.226 28.6942C493.02 34.1248 547.532 39.2536 602.424 37.6464C653.023 36.1653 704.16 31.1407 754.808 34.6788C784.766 36.7687 810.21 43.055 838.19 48.6172C866.171 54.1794 895.429 56.571 924.927 56.9879C989.835 57.9149 1050.87 47.734 1114.53 43.1812C1186.77 38.0139 1260.84 39.7692 1331.81 29.8297",
    stroke: "url(#paint51_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.111 16.5114C-34.5428 18.8152 25.1426 44.4869 98.7483 39.3087C156.107 35.255 208.752 20.033 266.191 16.3468C323.39 12.6771 384.303 22.6276 440.304 28.0965C493.938 33.3296 548.151 37.9209 602.774 35.5237C653.871 33.2802 705.768 29.3472 756.865 33.7136C786.733 36.2698 812.476 42.8851 840.657 48.3212C868.317 53.653 897.576 55.7045 926.754 55.721C991.662 55.7648 1051.92 44.0261 1115.49 39.5939C1187.38 34.5803 1261.28 38.3816 1331.81 28.283",
    stroke: "url(#paint52_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.102 14.4106C-34.0537 16.7913 25.8114 42.6769 99.9464 37.6961C157.335 33.8564 210.36 19.0458 267.868 15.7546C325.007 12.4633 385.312 22.337 441.322 27.614C494.846 32.6386 548.79 36.7142 603.093 33.5382C654.74 30.5212 707.305 27.6798 758.872 32.858C788.73 35.8476 814.693 42.7975 843.083 48.1074C870.614 53.2527 899.623 54.9367 928.532 54.5637C993.34 53.7354 1052.97 40.4937 1116.45 36.1657C1187.93 31.2947 1261.64 37.1421 1331.84 26.8405",
    stroke: "url(#paint53_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.081 12.4414C-33.5838 14.9043 26.491 40.9654 101.115 36.2041C158.534 32.5344 211.958 18.2011 269.497 15.2225C326.516 12.2714 386.331 22.1286 442.312 27.2081C495.736 32.0407 549.41 35.6062 603.403 31.6677C655.629 27.8608 708.844 26.0945 760.77 32.0681C790.598 35.4965 816.781 42.7756 845.42 47.9758C872.781 52.9126 901.64 54.273 930.3 53.5215C994.938 51.8375 1054.05 37.1586 1117.42 32.9239C1188.57 28.168 1262.06 36.045 1331.92 25.5405",
    stroke: "url(#paint54_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.071 10.6089C-33.1746 13.1486 27.1199 39.3962 102.223 34.8269C159.672 31.3272 213.396 17.4272 271.064 14.7778C327.983 12.1667 387.359 22.0075 443.25 26.9115C496.604 31.6015 550.009 34.6294 603.683 29.9449C656.518 25.3372 710.211 24.6241 762.587 31.3711C792.355 35.2109 818.788 42.8191 847.617 47.8986C874.838 52.6928 903.537 53.6857 931.897 52.5776C996.306 50.0598 1055.01 34.026 1118.26 29.8462C1189.16 25.1781 1262.35 35.0737 1331.9 24.3169",
    stroke: "url(#paint55_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.062 8.92529C-32.7055 11.5254 27.7488 37.9485 103.272 33.5602C160.77 30.2251 214.824 16.7365 272.552 14.4107C329.381 12.1233 388.298 21.9641 444.138 26.7144C497.443 31.2508 550.588 33.7741 603.962 28.36C657.336 22.946 711.559 23.2641 764.345 30.7571C794.042 34.9754 820.735 42.825 849.724 47.8825C876.685 52.5945 905.425 53.1869 933.435 51.7223C997.584 48.4311 1055.96 31.1027 1119.08 26.9777C1189.67 22.3645 1262.65 34.2623 1331.9 23.2147",
    stroke: "url(#paint56_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 7.35645C-32.2455 10.0114 28.3386 36.61 104.311 32.3918C161.789 29.2157 216.162 16.1331 273.96 14.109C330.66 12.1232 389.197 21.997 444.978 26.6102C498.252 30.9985 551.147 33.0445 604.212 26.9173C658.275 20.6805 712.818 21.9805 765.983 30.2086C795.621 34.7834 822.543 42.9292 851.701 47.9154C878.553 52.5067 907.143 52.77 934.863 51.0092C965.111 49.0838 994.599 44.6736 1023.64 39.7806C1054.97 34.5091 1087.22 26.4675 1119.86 24.3392C1190.21 19.7479 1262.94 33.6205 1331.91 22.2438",
    stroke: "url(#paint57_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 5.98486C-31.886 8.68368 28.8079 35.4524 105.22 31.3767C162.748 28.3049 217.411 15.5843 275.279 13.8619C331.888 12.1559 390.006 22.09 445.737 26.588C499.011 30.8776 551.697 32.4409 604.452 25.6226C659.104 18.5574 714.007 20.8009 767.561 29.7421C797.069 34.6789 824.22 43.0716 853.529 47.9865C880.271 52.4681 908.731 52.4352 936.182 50.3727C966.369 48.1127 995.687 43.3184 1024.56 38.1128C1055.66 32.5067 1087.96 24.0483 1120.59 21.9035C1190.72 17.3012 1263.22 33.1211 1331.92 21.3549",
    stroke: "url(#paint58_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 4.73975C-31.5465 7.48244 29.3072 34.4102 106.048 30.4553C163.617 27.4822 218.539 15.1455 276.457 13.67C332.987 12.2273 390.715 22.2765 446.406 26.6594C499.69 30.8447 552.186 31.9692 604.632 24.4652C659.913 16.5827 715.065 19.7094 768.999 29.3362C798.397 34.5803 825.748 43.2307 855.206 48.0908C881.839 52.4791 910.128 52.1719 937.38 49.8406C967.497 47.2625 996.666 42.1062 1025.39 36.6154C1056.28 30.7076 1088.62 21.8761 1121.25 19.6984C1191.15 15.0358 1263.48 32.7811 1331.95 20.5925",
    stroke: "url(#paint59_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 3.64795C-31.237 6.39064 29.7166 33.5049 106.787 29.6432C164.426 26.7524 219.627 14.7559 277.605 13.5217C334.075 12.3149 391.444 22.5122 447.075 26.8073C500.379 30.9158 552.725 31.6234 604.851 23.4776C660.702 14.7504 715.994 18.6999 770.307 28.963C799.605 34.5088 827.136 43.3841 856.714 48.2003C883.257 52.5173 911.447 51.9688 938.438 49.3906C968.516 46.5163 997.525 41.0309 1026.11 35.2767C1056.84 29.0837 1089.19 19.9505 1121.87 17.7235C1191.63 12.9621 1263.78 32.5889 1331.95 19.9176",
    stroke: "url(#paint60_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 2.71582C-30.9474 5.45852 30.0661 32.7428 107.436 28.9415C165.085 26.111 220.536 14.4326 278.564 13.3904C334.974 12.3975 391.963 22.7759 447.594 27.0106C500.929 31.0698 553.175 31.3989 605.001 22.6223C661.431 13.0613 716.753 17.7568 771.465 28.6562C800.634 34.4707 828.325 43.5491 858.012 48.3323C884.475 52.6 912.525 51.843 939.327 49.0454C969.365 45.9023 998.244 40.1207 1026.71 34.1252C1057.3 27.6798 1089.62 18.3108 1122.39 16.0234C1192 11.114 1264.06 32.5893 1331.96 19.3585",
    stroke: "url(#paint61_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 1.93652C-31.3169 4.67922 29.4969 31.9636 106.418 28.4255C167.202 25.6334 225.958 13.0225 287.291 13.2803C339.727 13.4997 392.343 22.962 444.139 27.0322C499.171 31.3547 551.846 31.234 605.141 21.9801C664.237 11.7444 719.609 17.1256 776.568 29.2977C802.102 34.7501 826.427 42.1883 852.151 47.2952C879.372 52.6983 909.26 52.1717 937.27 49.1712C969.055 45.7703 999.482 39.2975 1029.46 32.7151C1059.68 26.0558 1091.8 16.6813 1124.38 14.4871C1193.29 9.87389 1264.95 32.6492 1331.95 18.9138",
    stroke: "url(#paint62_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 1.32227C-31.1071 4.02656 29.7066 31.4919 106.837 27.9484C167.641 25.1508 226.667 12.8361 287.981 13.2475C340.376 13.6041 392.722 23.3297 444.489 27.4053C499.561 31.7388 552.226 31.3109 605.261 21.4537C664.956 10.3512 720.038 16.3632 777.467 29.1332C802.881 34.7832 827.276 42.2872 853.069 47.3996C880.231 52.8082 909.989 52.1718 937.839 49.0013C969.604 45.3864 999.911 38.6339 1029.8 31.8759C1059.98 25.0521 1092.09 15.5733 1124.75 13.2694C1193.53 8.45328 1265.27 32.9346 1331.96 18.5354",
    stroke: "url(#paint63_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 0.883301C-30.9574 3.54372 29.8065 31.1736 107.157 27.5752C167.971 24.7448 227.127 12.6933 288.52 13.2364C340.895 13.6972 392.992 23.7354 444.738 27.844C499.84 32.2323 552.585 31.5357 605.281 21.086C665.555 9.13881 720.198 15.6555 778.116 28.963C803.47 34.783 827.925 42.3638 853.738 47.5366C880.88 52.9726 910.378 52.2869 938.209 48.9682C1002.51 41.2887 1060.12 17.2462 1125.03 12.3971C1193.69 7.2683 1265.61 33.4007 1331.96 18.2775",
    stroke: "url(#paint64_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 0.604492C-30.8375 3.21005 29.9063 31.0045 107.347 27.3183C168.17 24.4166 227.526 12.601 288.889 13.2319C341.275 13.7804 393.141 24.1697 444.868 28.3496C499.99 32.8037 552.915 31.9041 605.311 20.8895C666.114 8.10302 720.148 14.9982 778.615 28.8433C803.759 34.784 828.275 42.6555 854.148 47.6253C881.629 52.8967 910.238 52.4689 938.368 49.0021C1002.78 41.0592 1060.07 16.9948 1125.21 11.7947C1193.78 6.3093 1266.01 34.038 1331.92 18.1139",
    stroke: "url(#paint65_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.001 0.499512C-30.7577 3.02828 29.8764 30.9873 107.396 27.164C168.22 24.1635 227.656 12.5454 289.139 13.2256C341.535 13.8071 393.201 24.6352 444.918 28.9138C500.04 33.4722 553.244 32.4245 605.331 20.8558C666.604 7.23557 719.878 14.3776 778.904 28.7493C832.828 41.8703 877.255 56.807 938.319 49.1165C1002.9 40.9817 1059.92 17.1202 1125.29 11.5032C1193.78 5.61738 1266.39 34.8435 1332 18.0857",
    stroke: "url(#paint66_linear_171658_143081)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171658_143081",
    x1: 1036580,
    y1: 915.774,
    x2: 1036580,
    y2: 444.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171658_143081",
    x1: 1036580,
    y1: 1342.54,
    x2: 1036580,
    y2: 551.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171658_143081",
    x1: 1036580,
    y1: 2051.25,
    x2: 1036580,
    y2: 734.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171658_143081",
    x1: 1036580,
    y1: 2830.71,
    x2: 1036580,
    y2: 936.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171658_143081",
    x1: 1036580,
    y1: 3779.38,
    x2: 1036580,
    y2: 1183.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_171658_143081",
    x1: 1036560,
    y1: 4776.87,
    x2: 1036560,
    y2: 1443.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_171658_143081",
    x1: 1036580,
    y1: 5777.35,
    x2: 1036580,
    y2: 1704.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_171658_143081",
    x1: 1036560,
    y1: 6728.37,
    x2: 1036560,
    y2: 1953.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_171658_143081",
    x1: 1036580,
    y1: 7671.77,
    x2: 1036580,
    y2: 2198.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_171658_143081",
    x1: 1036580,
    y1: 8396.26,
    x2: 1036580,
    y2: 2386.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_171658_143081",
    x1: 1036580,
    y1: 8932.88,
    x2: 1036580,
    y2: 2524.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_171658_143081",
    x1: 1036610,
    y1: 9219.1,
    x2: 1036610,
    y2: 2596.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_171658_143081",
    x1: 1036580,
    y1: 9345.85,
    x2: 1036580,
    y2: 2624.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_171658_143081",
    x1: 1036560,
    y1: 9474.33,
    x2: 1036560,
    y2: 2653.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_171658_143081",
    x1: 1036560,
    y1: 9546.8,
    x2: 1036560,
    y2: 2668.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_171658_143081",
    x1: 1036600,
    y1: 9567.25,
    x2: 1036600,
    y2: 2669.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_171658_143081",
    x1: 1036580,
    y1: 9542.15,
    x2: 1036580,
    y2: 2658.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_171658_143081",
    x1: 1036580,
    y1: 9475.78,
    x2: 1036580,
    y2: 2636.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_171658_143081",
    x1: 1036580,
    y1: 9324.15,
    x2: 1036580,
    y2: 2593.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_171658_143081",
    x1: 1036590,
    y1: 9222.54,
    x2: 1036590,
    y2: 2562.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_171658_143081",
    x1: 1036550,
    y1: 9099.87,
    x2: 1036550,
    y2: 2526.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_171658_143081",
    x1: 1036580,
    y1: 8969.66,
    x2: 1036580,
    y2: 2488.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_171658_143081",
    x1: 1036610,
    y1: 8831.99,
    x2: 1036610,
    y2: 2449.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_171658_143081",
    x1: 1036560,
    y1: 8692.51,
    x2: 1036560,
    y2: 2408.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_171658_143081",
    x1: 1036580,
    y1: 8510.9,
    x2: 1036580,
    y2: 2357.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_171658_143081",
    x1: 1036550,
    y1: 8380.93,
    x2: 1036550,
    y2: 2320.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_171658_143081",
    x1: 1036560,
    y1: 8265.09,
    x2: 1036560,
    y2: 2286.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_171658_143081",
    x1: 1036550,
    y1: 8174.05,
    x2: 1036550,
    y2: 2259.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_171658_143081",
    x1: 1036610,
    y1: 8095.52,
    x2: 1036610,
    y2: 2235.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_171658_143081",
    x1: 1036580,
    y1: 8056.57,
    x2: 1036580,
    y2: 2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_171658_143081",
    x1: 1036580,
    y1: 8037.88,
    x2: 1036580,
    y2: 2213.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_171658_143081",
    x1: 1036600,
    y1: 7986.44,
    x2: 1036600,
    y2: 2197.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_171658_143081",
    x1: 1036580,
    y1: 7909.14,
    x2: 1036580,
    y2: 2173.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_171658_143081",
    x1: 1036600,
    y1: 7796.37,
    x2: 1036600,
    y2: 2140.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_171658_143081",
    x1: 1036580,
    y1: 7661.31,
    x2: 1036580,
    y2: 2101.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_171658_143081",
    x1: 1036600,
    y1: 7499.84,
    x2: 1036600,
    y2: 2055.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_171658_143081",
    x1: 1036570,
    y1: 7319.82,
    x2: 1036570,
    y2: 2004.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_171658_143081",
    x1: 1036580,
    y1: 7115.97,
    x2: 1036580,
    y2: 1947.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_171658_143081",
    x1: 1036560,
    y1: 6889.73,
    x2: 1036560,
    y2: 1885.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_171658_143081",
    x1: 1036580,
    y1: 6656.38,
    x2: 1036580,
    y2: 1820.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_171658_143081",
    x1: 1036580,
    y1: 6404.18,
    x2: 1036580,
    y2: 1750.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_171658_143081",
    x1: 1036580,
    y1: 6150.05,
    x2: 1036580,
    y2: 1680.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_171658_143081",
    x1: 1036580,
    y1: 5882.63,
    x2: 1036580,
    y2: 1607.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_171658_143081",
    x1: 1036580,
    y1: 5616.42,
    x2: 1036580,
    y2: 1534.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_171658_143081",
    x1: 1036530,
    y1: 5355.81,
    x2: 1036530,
    y2: 1462.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_171658_143081",
    x1: 1036610,
    y1: 5076.69,
    x2: 1036610,
    y2: 1386.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_171658_143081",
    x1: 1036580,
    y1: 4904.6,
    x2: 1036580,
    y2: 1339.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_171658_143081",
    x1: 1036580,
    y1: 4692.54,
    x2: 1036580,
    y2: 1280.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_171658_143081",
    x1: 1036600,
    y1: 4523.98,
    x2: 1036600,
    y2: 1234.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_171658_143081",
    x1: 1036580,
    y1: 4387.62,
    x2: 1036580,
    y2: 1197.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_171658_143081",
    x1: 1036540,
    y1: 4274.25,
    x2: 1036540,
    y2: 1166.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_171658_143081",
    x1: 1036560,
    y1: 4177.81,
    x2: 1036560,
    y2: 1139.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_171658_143081",
    x1: 1036550,
    y1: 4099.37,
    x2: 1036550,
    y2: 1118.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_171658_143081",
    x1: 1036560,
    y1: 4101.83,
    x2: 1036560,
    y2: 1117.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_171658_143081",
    x1: 1036610,
    y1: 4208.68,
    x2: 1036610,
    y2: 1145.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_171658_143081",
    x1: 1036580,
    y1: 4319.38,
    x2: 1036580,
    y2: 1173.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_171658_143081",
    x1: 1036580,
    y1: 4432.04,
    x2: 1036580,
    y2: 1203.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_171658_143081",
    x1: 1036540,
    y1: 4547.93,
    x2: 1036540,
    y2: 1233.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_171658_143081",
    x1: 1036550,
    y1: 4655.35,
    x2: 1036550,
    y2: 1261.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_171658_143081",
    x1: 1036570,
    y1: 4760.38,
    x2: 1036570,
    y2: 1288.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_171658_143081",
    x1: 1036570,
    y1: 4857.25,
    x2: 1036570,
    y2: 1314.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_171658_143081",
    x1: 1036580,
    y1: 4946.17,
    x2: 1036580,
    y2: 1337.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_171658_143081",
    x1: 1036570,
    y1: 5031.41,
    x2: 1036570,
    y2: 1359.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_171658_143081",
    x1: 1036580,
    y1: 5095.56,
    x2: 1036580,
    y2: 1376.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_171658_143081",
    x1: 1036580,
    y1: 5151.29,
    x2: 1036580,
    y2: 1391.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_171658_143081",
    x1: 1036550,
    y1: 5185.34,
    x2: 1036550,
    y2: 1400.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_171658_143081",
    x1: 1036610,
    y1: 5156.97,
    x2: 1036610,
    y2: 1392.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592CB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavesBg);
export default __webpack_public_path__ + "static/media/waves_bg.be42796fc7510752122356ff9b8f808c.svg";
export { ForwardRef as ReactComponent };